import {useSuspenseQuery} from "@apollo/client";
import {format, parseISO} from "date-fns";
import {FiClock} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {durationSecFn, roundDurationSecs} from "@/lib/format.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {GQL_PUBLIC_PROFILES_RECENT_OUTAGES_QUERY} from "@/lib/queries/isitdown.ts";
import {PublicProfilesRecentOutagesResult} from "@/lib/types/isitdown.ts";
import {MarketingTable} from "@/marketingPages/components/marketingtable/MarketingTable.tsx";

import styles from "./PublicProfilesRecentOutages.module.scss";

export const PublicProfilesRecentOutages = () => {
  const {data} = useSuspenseQuery<PublicProfilesRecentOutagesResult>(GQL_PUBLIC_PROFILES_RECENT_OUTAGES_QUERY);
  const items = data?.publicProfilesRecentOutages.items || [];
  return (
    <>
      <div className={styles.recentOutagesContainer}>
        {items.length > 0 && (
          <MarketingTable
            variant="white"
            rows={items}
            specs={[
              {
                fieldTitle: "Incident Name",
                fieldName: "incident_title",
                accessor: (item) => item.incident_title,
                meta: {columnClassName: styles.incidentTitle},
              },
              {
                fieldTitle: "Service",
                fieldName: "service",
                accessor: (item) => (
                  <div className="d-flex align-items-center gap-1 pe-lg-5 text-nowrap">
                    <img src={item.group_logo} alt={item.group_name} className={styles.groupIcon} />
                    <div className="pe-lg-5">{item.group_name}</div>
                  </div>
                ),
              },
              {
                fieldTitle: "Duration",
                fieldName: "duration",
                accessor: (item) => (
                  <div className="d-flex align-items-center gap-1 pe-lg-5 text-nowrap">
                    <Icon icon={FiClock} removeDivDimensions />
                    {durationSecFn(roundDurationSecs(item.incident_duration))}
                  </div>
                ),
              },
              {
                fieldTitle: "Started",
                fieldName: "started",
                accessor: (item) => format(parseISO(item.incident_start), "PP pp"),
                meta: {columnClassName: "text-nowrap"},
              },
            ]}
          />
        )}
      </div>
      <a href={`${URL_ORIGINAL_WEBSITE}/accounts/register`} className="pulse-color-green-500 marketingTextBtn">
        Sign Up to View Full Incident History →
      </a>
    </>
  );
};
